import React from 'react';
import './Loader.css';

export default ({loading}) => {
  return (
    <div>
      { !loading ? null :
      <div className="loader">
        <div className="loader-body">
          <div className="loader-inner">
            <div className="loader-line-wrap">
              <div className="loader-line" />
            </div>
            <div className="loader-line-wrap">
              <div className="loader-line" />
            </div>
            <div className="loader-line-wrap">
              <div className="loader-line" />
            </div>
            <div className="loader-line-wrap">
              <div className="loader-line" />
            </div>
            <div className="loader-line-wrap">
              <div className="loader-line" />
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/Loader.js